// extracted by mini-css-extract-plugin
export var chip = "_cc-0";
export var filterDropdown = "_cc-5";
export var filterItem = "_cc-6";
export var icon = "_cc-1";
export var removeButton = "_cc-3";
export var removeIcon = "_cc-4";
export var separator = "_cc-2";